/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ComputeSecret = {
  createdAt: Date;
  id: string;
  keys: Array<string>;
  name: string;
};

/** @internal */
export const ComputeSecret$inboundSchema: z.ZodType<
  ComputeSecret,
  z.ZodTypeDef,
  unknown
> = z.object({
  created_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
  id: z.string(),
  keys: z.array(z.string()),
  name: z.string(),
}).transform((v) => {
  return remap$(v, {
    "created_at": "createdAt",
  });
});
/** @internal */
export type ComputeSecret$Outbound = {
  created_at: string;
  id: string;
  keys: Array<string>;
  name: string;
};

/** @internal */
export const ComputeSecret$outboundSchema: z.ZodType<
  ComputeSecret$Outbound,
  z.ZodTypeDef,
  ComputeSecret
> = z.object({
  createdAt: z.date().transform(v => v.toISOString()),
  id: z.string(),
  keys: z.array(z.string()),
  name: z.string(),
}).transform((v) => {
  return remap$(v, {
    createdAt: "created_at",
  });
});

export function computeSecretToJSON(computeSecret: ComputeSecret): string {
  return JSON.stringify(ComputeSecret$outboundSchema.parse(computeSecret));
}
export function computeSecretFromJSON(
  jsonString: string,
): SafeParseResult<ComputeSecret, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ComputeSecret$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ComputeSecret' from JSON`,
  );
}
